import React, { useRef, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import classnames from 'classnames';
import css from './single-line-text-resizer.scss';
export const SingleLineTextResizer = ({
  children,
  minFontSize,
  className,
  unit = 'rem'
}) => {
  const [isCalculated, setIsCalculated] = useState(false);
  const [calculatedFontSize, setCalculatedFontSize] = useState(null);
  const minHiddenWrapperRef = useRef(null);
  const originHiddenWrapperRef = useRef(null);
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (unit === 'rem') {
      var _wrapperRef$current$c, _wrapperRef$current, _originHiddenWrapperR, _originHiddenWrapperR2, _minHiddenWrapperRef$, _minHiddenWrapperRef$2;
      const maxAvailableSize = (_wrapperRef$current$c = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.clientWidth) !== null && _wrapperRef$current$c !== void 0 ? _wrapperRef$current$c : 0;
      const originSize = (_originHiddenWrapperR = (_originHiddenWrapperR2 = originHiddenWrapperRef.current) === null || _originHiddenWrapperR2 === void 0 ? void 0 : _originHiddenWrapperR2.clientWidth) !== null && _originHiddenWrapperR !== void 0 ? _originHiddenWrapperR : 0;
      const minPossibleSize = (_minHiddenWrapperRef$ = (_minHiddenWrapperRef$2 = minHiddenWrapperRef.current) === null || _minHiddenWrapperRef$2 === void 0 ? void 0 : _minHiddenWrapperRef$2.clientWidth) !== null && _minHiddenWrapperRef$ !== void 0 ? _minHiddenWrapperRef$ : 0;
      if (maxAvailableSize && minPossibleSize) {
        let newFontSize = null;
        if (minPossibleSize >= maxAvailableSize) {
          newFontSize = minFontSize;
        } else if (minPossibleSize < maxAvailableSize && originSize > maxAvailableSize) {
          const ratio = maxAvailableSize / minPossibleSize;
          newFontSize = minFontSize * ratio;
        }
        setCalculatedFontSize(newFontSize);
        setIsCalculated(true);
      }
    }
  }, [minFontSize, children, className, unit]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: getFontStyle(calculatedFontSize, unit),
    className: classnames(css.wrapper, className),
    ref: wrapperRef
  }, isCalculated ? children : null), /*#__PURE__*/ReactDom.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: getFontStyle(minFontSize, unit),
    className: classnames(css.measureWrapper, className),
    ref: minHiddenWrapperRef
  }, children), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.measureWrapper, className),
    ref: originHiddenWrapperRef
  }, children)), document.body));
};
const getFontStyle = (size, unit) => {
  return size && unit ? {
    fontSize: `${size}${unit}`
  } : undefined;
};